
import { format } from 'date-fns';

export default {

    filters: {
        mascaraCpf(valor) {
            const arr = valor.split('')
            arr.splice(3, 0, '.')
            arr.splice(7, 0, '.')
            arr.splice(11, 0, '-')
            return arr.join('')
        }
    },
    methods: {
        formatarData(data) {
            return format(String(data), 'DD/MM/YYYY')
        },

        formatarDataHora (data) {
            return format(String(data), 'DD/MM/YYYY HH:mm');
        },

        converterStringNumber(str) {
            if(str) {
                str = new String(str)
                let value = str.replace('.', '');
                value = str.replace(',', '.')
                return Number(value)
            }
            return 0
        },

        validarCnpj(cnpj) {
            return this.validaCnj(cnpj, false);
        },

        validarCnpj(cnpj, aceitarZeros) {

            cnpj = cnpj.replace(/[^\d]+/g, '');
        
            if (cnpj == '') return false;
        
            if (cnpj.length != 14)
                return false;
        
         
            if (cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999")
                return false;

            if (!aceitarZeros &&
                cnpj == "00000000000000")
                return false;
        
         
            var tamanho = cnpj.length - 2
            var numeros = cnpj.substring(0, tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) return false;
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                return false;
        
            return true;
        
        },

        validarCpf(cpf) {
            return this.validarCpf(cpf, false);
        },

        validarCpf(cpf, aceitaZeros) {
            cpf = cpf.replace(/[^\d]+/g, '');
        
            if (cpf == '') return false;

            if (cpf.length != 11 ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                return false;

            if (!aceitaZeros &&
                cpf == "00000000000")
                return false;
    
            let add = 0;
    
            for (let i = 0; i < 9; i++)
                    add += parseInt(cpf.charAt(i)) * (10 - i);
            let rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                return false;
            add = 0;
                    for (let i = 0; i < 10; i++)
                    add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                return false;
            return true;
        },

        validaCnj(cnj) {

            if (cnj != '' && cnj.length < 20) {
                return false;
            }

            cnj = cnj.replace(/[^\d]+/g, '');

            var cnjSemDigito = cnj.substring(0, 7) + cnj.substring(9, 20) + "00";
            var digitoVerificador = cnj.substring(7, 9);

            var nnnnnnn = parseInt(cnjSemDigito.substring(0, 7));
            var ajtr = cnjSemDigito.substring(7, 14);
            var oooo00 = cnjSemDigito.substring(14, 20);

            /*
             * F�rmula CNJ primeira etapa R1 = (NNNNNNN mod 97)
             */
            var r1 = nnnnnnn % 97;

            /*
             * F�rmula CNJ segunda etapa R2 = ((R1 concatenado com AAAAJTR) mod 97)
             */
            var r2 = parseInt(r1 + '' + ajtr) % 97;

            /*
             * F�rmula CNJ terceira etapa R3 = ((R2 concatenado com OOOO00) mod 97)
             */
            var r3 = (r2 + '' + oooo00) % 97;

            /*
             * F�rmula CNJ quarta etapa DD = 98 - (R3 mod 97)
             */
            var d1d0 = 98 - r3;
            if (d1d0.toString().length == 1) {
                d1d0 = 0 + '' + d1d0;
            }

            // Compara d�gito calculado com informado
            var big = cnjSemDigito.substring(0, 18) + '' + d1d0;
            if (digitoVerificador == d1d0 && this.modulo(big, 97) == 1) {
                return true;
            } else {
                return false;
            }
        },

        modulo (divident, divisor) {
            var cDivident = '';
            var cRest = '';

            for (var i in divident ) {
                var cChar = divident[i];
                var cOperator = cRest + '' + cDivident + '' + cChar;

                if ( cOperator < parseInt(divisor) ) {
                    cDivident += '' + cChar;
                } else {
                    cRest = cOperator % divisor;
                    if ( cRest == 0 ) {
                        cRest = '';
                    }
                    cDivident = '';
                }

            }
            cRest += '' + cDivident;
            if (cRest == '') {
                cRest = 0;
            }
            return cRest;
        },

        isEmpty (value) {
            return value == null || value == '' || value.toString().trim() == '';
        },
        exibirErro(error) {
            this.$store.commit("setMessages", {message: 'Erro!', errors: [error]});
            window.scrollTo(0,0);
        },
        exibirMensagem(msg) {
            this.$store.commit("setMessages", { message: 'Aten��o', variant: 'danger', errors: [msg]});
            window.scrollTo(0,0);
        },
    }
}